<template>
  <router-view />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
@import 'sweetalert2/src/sweetalert2.scss';
</style>


<style src="@vueform/multiselect/themes/default.css"></style>